import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box, Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';
import { routes } from 'utils/routing';

import theme from './theme';

export interface ISubcategoryBreadcrumbs {
  currentSectionName: string;
}

const StyledLink = Link.withConfig({
  color: theme.wrapperColor,
});

export const SubcategoryBreadcrumbs: FC<React.PropsWithChildren<ISubcategoryBreadcrumbs>> = ({
  currentSectionName,
}) => {
  return (
    <Box style={styles.container}>
      <StyledLink to={routes.supportCategories} isInline isUnderlined>
        {t('supportTopicsAll')}
      </StyledLink>
      <Typography fontSize="lg" style={styles.currentSectionName}>
        {' / ' + currentSectionName}
      </Typography>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: spacing.$4,
    alignSelf: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  currentSectionName: {
    alignSelf: 'flex-start',
  },
});
